import { CustomerExistsResponse } from '@porterin/booking-flow/src/auth/domain/api-models/CustomerExistsApiModel';
import { CustomerExists } from '@porterin/booking-flow/src/auth/domain/entities/CustomerExists';

const toCustomerExistsEntity = (
  apiModel: CustomerExistsResponse,
): CustomerExists => {
  return {
    exists: apiModel.exists,
  };
};

export { toCustomerExistsEntity };
